'use client';
import React from 'react';
import './CTASection.scss';
import { LANDING_OR_PRODUCT_PAGE_QUERY_RESULT } from '@/sanity.types';
import { LandingPortableText } from '@/components/landingPortableText/landingPortableText';
import { PortableTextBlock } from 'next-sanity';
import Button from '@/componentv2/button/button';
import Typography from '@/componentv2/typography/typography';

interface CtaSectionProps {
  data: NonNullable<LANDING_OR_PRODUCT_PAGE_QUERY_RESULT>;
}

export default function CTASection({ data }: CtaSectionProps) {
  const ctaContent = data?._type === 'productPage' ? data?.cta : null;
  const ctaBgColor =
    data?._type === 'productPage' ? data?.ctaBackgroundCreamColor : null;

  return (
    <section className={`cta-section ${ctaBgColor ? 'cream-bg' : ''}`}>
      <div className="container">
        <div className="cta-content">
          {ctaContent?.title && (
            <div className="cta-title">
              <LandingPortableText
                value={ctaContent?.title as PortableTextBlock[]}
              />
            </div>
          )}
          {ctaContent?.description && (
            <Typography style="paragraph" className="cta-description">
              {ctaContent?.description}
            </Typography>
          )}
          {ctaContent?.button?.text && (
            <div className="cta-button-container">
              <Button
                as="a"
                href={ctaContent?.button?.link}
                variant="primary"
                className="cta-button"
              >
                {ctaContent?.button?.text}
              </Button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
